module.exports = __webpack_public_path__ + "img/jean_baptiste_guegan.b4fd38d3.jpg";